/*
 * File: ui-relation-create.ts
 * File Created: 2024-09-09 09:41:37
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-05 12:27:38
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    EUITagRuleUnion,
} from "../core";

// @uiRelationCreate: on read convert to `[...]`, and on write convert back to `{ create: [...] }`.

@UITag.set()
export class uiRelationCreate extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement, EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == null) return null;
        if (rule == false) return null;

        let moreTags: IUITagMoreTagsUnit[] = [
            /// parse string to object
            {
                tag: "uiConverter",
                rule: (o) => {
                    return (
                        o.value?.create ?? o.value?.createMany?.data ?? o.value ?? null
                    );
                },
            },
            /// convert object back to string
            {
                tag: "uiSubmitConverter",
                rule: (o) => {
                    if (Array.isArray(o.value)) {
                        /// ignore the pseudo array element
                        if (o.value.filter((o) => o).length === 0) return null;
                        return { createMany: { data: o.value } };
                    }
                    return { create: o.value };
                },
            },
        ];

        return {
            specials: {
                moreTags,
            },
        };
    }
}
